module.exports = __webpack_public_path__ + "static/media/Beach7.45e3513c.jpg";